import React, { useState, useEffect, useContext, useCallback, useRef } from "react";
import { Col, Row, Button, Form, Modal, Container } from "react-bootstrap";
import { identifyRetry } from "../redux/actions/checkInActions";
import { useLocation, useNavigate } from 'react-router-dom';
import { getCDNImage } from '../globals';
import { T } from "react-translator-component";
import Screen from '../components/Screen';
import { AlertContext } from '../context/alert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { HotelContext } from "../context/hotel";
import { CheckInContext } from "../context/checkin";
import { UserContext } from "../context/user";
import { i18nValue } from '../functions';
import { QrReader } from 'react-qr-reader';
import Reservation from "../components/Reservation";

const CheckInIdentifyLanding = ({ navigation, route }) => {
  const navigate = useNavigate();
  const { data : hotel } = useContext(HotelContext);

  return (
    <div style={{ backgroundImage: 'url(https://images.rawpixel.com/image_1000/czNmcy1wcml2YXRlL3Jhd3BpeGVsX2ltYWdlcy93ZWJzaXRlX2NvbnRlbnQvbHIvcHgxMDE0MDA0LWltYWdlLWt3dnk3bXVrLmpwZw.jpg)', height: '100%', paddingTop: 60, backgroundSize: 'auto 100%' }}>
      <Container className="p-3" style={{ maxWidth: 230, border: "1px solid #EEE", background: "#FFF", borderRadius: 8, marginBottom: 90 }}>
        <Row>
          <Col>
            <img className="w-100" src={getCDNImage(hotel.logo)} />
          </Col>
        </Row>
      </Container>

      <Container style={{ maxWidth: 500, textAlign: "center" }}>
        <Row>
          <Col>
            <p style={{ color: "#FFF", textShadow: "1px 1px 3px rgba(0, 0, 0, 0.75)" }}>Please complete the following information to get your access information.</p>
          </Col>
        </Row>
      </Container>

      <Container className="py-3" style={{ maxWidth: 500, border: "1px solid #EEE", background: "rgba(255, 255, 255, 0.8)", borderRadius: 8 }}>
        <Row>
          <Col lg={6} md={12}>
            <span className="general-text-sm">Name</span>
            <Form.Control type={'input'} />
          </Col>
          <Col lg={6} md={12}>
            <span className="general-text-sm">Surname</span>
            <Form.Control type={'input'} />
          </Col>
        </Row>

        <Row>
          <Col lg={6} md={12}>
            <span className="general-text-sm">ID</span>
            <Form.Control type={'input'} />
          </Col>
          <Col lg={6} md={12}>
            <span className="general-text-sm">Departure Date</span>
            <Form.Control type={'input'} />
          </Col>
        </Row>

        <Row className="mt-3">
          <Col>
            <Button
            size={'lg'}
            variant={'primary'}
            type={'button'}
            block={true}
            // onClick={handleContinue}
          >
            NEXT
          </Button>
          </Col>
        </Row>
      </Container>

    </div>
  );
}

export default CheckInIdentifyLanding;